import styles from '@features/cms/components/collections/NewSpacingBlock/NewSpacingBlock.styles';
import { INewSpacingBlock } from '@features/cms/services/page/NewSpacingBlock';
type PropsType = {
  data: INewSpacingBlock;
};
const NewSpacingBlock = ({
  data
}: PropsType) => {
  const {
    marginTop,
    marginBottom,
    background,
    code
  } = data;
  return <div id={code} sx={styles.newSpacingBlock(marginTop, marginBottom, background)} data-testid="NewSpacingBlock" />;
};
export default NewSpacingBlock;